import { DateUtilsService, TranslationService } from '@sdbn/common';
import { Component, OnInit } from '@angular/core';
import { ClientContextService, CommonBrowserStorageService, HttpService } from '@sdbn/appclient';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { VisitHistory, VisitHistorySelection } from '../export-visitor-log.model';
import { environment } from 'src/environments/environment';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';

@Component({
  selector: 'app-export-visitor-log',
  templateUrl: './export-visitor-log.component.html',
  styleUrls: ['./export-visitor-log.component.scss']
})
export class ExportVisitorLogComponent implements OnInit {

  COMPONENT_ID = 'export-visit-history';

  SELECTION_STORAGE_KEY = 'selection';

  columnsToDisplay = [
    'createdAt',
    'dayOfWeek',
    'company',
    'name',
    'arrivedAt',
    'allDay',
    'visitedPerson',
    'instructionsDone',
    'instructionFinish',
    'entranceAllowedWithoutGuide',
    'phone',
    'entranceAllowedByCar',
    'numberPlate',
    'chip',
    'chipNumber',
    'terminalRegistration',
    'access',
    'leave',
    'accessGuidedBy',
    'leaveGuidedBy',
    'filler'
  ];

  dataSource = new MatTableDataSource(new Array<VisitHistory>());

  selection = new VisitHistorySelection();//this.form.value.dateFrom, this.form.value.dateUntil, 200);

  formGroup = new FormGroup({
    dateFrom: new FormControl(null, []),
    dateUntil: new FormControl(null, []),
    query: new FormControl(null, [])
  });

  constructor(
    public translationService: TranslationService,
    private http: HttpService,
    private dateUtils: DateUtilsService,
    private commonBrowserStorageService: CommonBrowserStorageService,
    private clientContextService: ClientContextService
  ) {

  }

  ngOnInit(): void {

    this.loadSelectionFromStorage();

    this.formGroup.valueChanges.subscribe(value => {

      this.selection.dateFrom  = this.dateUtils.convertDateToTimestamp(value.dateFrom);
      this.selection.dateUntil  = this.dateUtils.convertDateToTimestamp(value.dateUntil);
      this.selection.query  = value.query;

      this.writeSelectionToStorage();

    });

  }

  showDetails() {

    const url = `${environment.visitHistoryEndpoint}/search`;
    this.http.postWithContext<Array<any>>(url, this.selection).subscribe(result => {

      let data = new Array<VisitHistory>();
      for (let item of result) {
        data.push(new VisitHistory(item));
      }
      this.dataSource.data = data;

    });

  }

  createExcel() {

    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'export-visit-log');

    // keep focus in current window
    window.focus();


    const url = `${environment.visitHistoryEndpoint}/create-excel`;
    this.http.postWithArraybufferResponse<any>(url, this.selection).subscribe(result => {

      const file = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }

  private loadSelectionFromStorage() {
    let storedSelection = this.commonBrowserStorageService.get(this.clientContextService.getUnit().key, this.COMPONENT_ID, this.SELECTION_STORAGE_KEY);
    if (storedSelection != null) {
      const selectionObject = JSON.parse(storedSelection);
      this.selection.dateFrom = selectionObject.dateFrom;
      this.selection.dateUntil = selectionObject.dateUntil;
      this.selection.query = selectionObject.query;

      this.formGroup.patchValue({

        dateFrom: this.dateUtils.parseDateFromTimestamp(this.selection.dateFrom),
        dateUntil: this.dateUtils.parseDateFromTimestamp(this.selection.dateUntil),
        query: this.selection.query

      });
    }
  }

  private writeSelectionToStorage() {
    this.commonBrowserStorageService.setPersistent(this.clientContextService.getUnit().key, this.COMPONENT_ID, this.SELECTION_STORAGE_KEY, JSON.stringify(this.selection));
  }

}
